import React, { useState, useEffect } from "react";
import styles from "./index.module.scss";
import {useRouter} from "next/router";
import Link from "next/link"
import getAbsoluteUrl from "../../../utils/getAbsoluteUrl";

export default function Pagination(props) {
  const { meta, size = 5 } = props;
  const router = useRouter();
  const count = meta.pages_count;
  const items = [...Array(count > size ? size : count).keys()];
  const [stateFirst, setStateFirst] = useState(true);
  const [stateLast, setStateLast] = useState(true);
  let arr = [];
  const setPage = (index) => {
    let page;
    const curPage = meta.page;
    const pageCount = meta.pages_count;
    const pagSize = curPage + 1 === pageCount ? 6 : size;
    if (curPage >= pagSize) {
      page = index + (curPage - pagSize) + Math.round(size / 2);
    }
    if (curPage === pageCount) {
      page = index + (curPage - pagSize) + 1;
    }
    if (curPage < pagSize) {
      page = index + 1;
    }
    arr = [...arr, page];

    return page;
  };

  useEffect(() => {
    const filterItems = arr.find((el) => el === 1);
    const filterItemsLast = arr.find((el) => el === meta.pages_count);
    if (filterItems) setStateFirst(false);
    if (filterItemsLast) setStateLast(false);
    if (!filterItems) setStateFirst(true);
    if (!filterItemsLast) setStateLast(true);
  }, [arr]);

  const url = (page) => {
    return getAbsoluteUrl(`/gallery/?${Object
      .entries({...router.query, page})
      .map((v) => `${v[0]}=${v[1]}`)
      .join("&")
    }`)
  };

  return (
    <>
      {items.length > 1 && (
        <div className={styles.root}>
          {stateFirst && (
            <>
              <Link href={url(1)}>
                <a
                  className={`${styles.item} `}
                >
                  1
                </a>
              </Link>
              <span className={`${styles.item} ${styles.dots}`}>...</span>
            </>
          )}
          {items.map((_, i) => {
            const _page = setPage(i);
            return (<Link href={url(_page)} key={i}>
              <a

                className={`${styles.itemMap} ${styles.item} ${
                  meta.page === _page && styles.active
                } `}
              >
                {_page}
              </a>
            </Link>);
          })}
          {stateLast && (
            <>
              <span className={`${styles.item} ${styles.dots}`}>...</span>
              <Link href={url(meta.pages_count)}>
                <a
                  className={`${styles.item} `}
                >
                  {meta.pages_count}
                </a>
              </Link>
            </>
          )}
        </div>
      )}
    </>
  );
}
